import { Coordinates } from '../../modules/stores/types';

export type AutocompleteSuggestion = {
  mainText: string;
  secondaryText: string;
  id: string;
};

export class PlacesAndAutocomplete {
  static isPlacesAvailable() {
    if (typeof google === 'undefined') {
      return false;
    }

    // eslint-disable-next-line no-undef
    return Boolean(google?.maps?.places);
  }

  static async getPlacesByStringSearch(search: string): Promise<Array<AutocompleteSuggestion>> {
    try {
      // eslint-disable-next-line no-undef
      const { AutocompleteSuggestion } = google.maps.places;

      // eslint-disable-next-line no-undef
      const request: google.maps.places.AutocompleteRequest = {
        input: search,
        includedRegionCodes: ['US'],
        region: 'US',
      };

      const { suggestions } = await AutocompleteSuggestion.fetchAutocompleteSuggestions(request);

      return (suggestions ?? [])
        .map((item) => ({
          id: item.placePrediction?.placeId,
          mainText: item.placePrediction?.mainText?.text,
          secondaryText: item.placePrediction?.secondaryText?.text,
        }))
        .filter((item): item is AutocompleteSuggestion => !!item.id && !!item.mainText && !!item.secondaryText);
    } catch (error) {
      return [];
    }
  }

  static async getPlaceCoordinates(placeId: string): Promise<Coordinates | null> {
    try {
      // eslint-disable-next-line no-undef
      const { Place } = (await google.maps.importLibrary('places')) as google.maps.PlacesLibrary;
      const placeLibrary = new Place({ id: placeId, requestedRegion: 'US' });
      const { place } = await placeLibrary.fetchFields({
        fields: ['location'],
      });

      const lat = place.location?.lat();
      const lng = place.location?.lng();

      if (lat === undefined || lng === undefined) {
        return null;
      }

      return {
        lat,
        lng,
      };
    } catch (error) {
      return null;
    }
  }
}
